// import { Http } from '../../../applications/Http.js'

import moment from 'moment'
import { Http } from '../../../applications/Http'
import Service from '../../../applications/Service'

class PlantingTrackingService extends Service {
    static messages = {
        update_success: 'Modification avec succès.',
        update_error: 'Erreur de modification.',
        delete_success: 'Suppression effectuée.',
        delete_error: 'Erreur de suppression.',
        create_success: 'Création  avec succès.',
        create_error: 'Erreur de création.'
    }
    static load() {
        this.setUrl('/api/plantation/trackings')
        return this
    }

    static async getByCode(id) {
        return await Http.get([this.url, id].join('/'), {})
    }

    static async addPlantingTracking(data) {
        try {
            data.tracking_date = moment(data.tracking_date).format()

            const response = await Http.put('/api/plantation/trackings', data)
            return response.data
        } catch (error) {
            throw new Error("Erreur lors de l'ajout .")
        }
    }

    static async updatePlantingTracking(id, data) {
        try {
            data.tracking_date = moment(data.tracking_date).format()
            const response = await Http.patch([this.url, id].join('/'), data)
            return response.data
        } catch (error) {
            throw new Error('Erreur lors de la mise à jour .')
        }
    }

    static async getAllPlantingTracking() {
        try {
            const response = await Http.get('/api/plantation/trackings')
            console.log('response user', response.data)
            return response.data
        } catch (error) {
            console.error("Une erreur s'est produite lors de la récupération des utilisateurs :", error)
            throw error
        }
    }
}

export default PlantingTrackingService
